import { render, staticRenderFns } from "./GmbServicePreviewChip.vue?vue&type=template&id=7fa6240f&scoped=true&"
import script from "./GmbServicePreviewChip.vue?vue&type=script&lang=js&"
export * from "./GmbServicePreviewChip.vue?vue&type=script&lang=js&"
import style0 from "./GmbServicePreviewChip.vue?vue&type=style&index=0&id=7fa6240f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa6240f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VChip,VDivider,VIcon,VList,VListItem,VListItemTitle,VMenu})
